import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/JobPositionPermissions'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import ErrorBoundary from '@/components/ErrorBoundary'
import LoadingIndicator from '@/components/LoadingIndicator'
import Form from './form'
import Resx from '@/components/Resx'

class JobPositionPermissionDetail extends React.Component {
  componentDidMount () {
    this.props.getPermissions(this.getJobAssignmentId())
  }
  getJobAssignmentId () {
    return this.props.match.params.jobAssignmentId
  }
  renderContent () {
    const { fetching, saving, jobPositionPermissions } = this.props.jobPositionPermissions

    if (fetching === true || saving === true) { return <LoadingIndicator /> }
    if (jobPositionPermissions) {
      return (
        <Form
          key={this.props.formKey}
          jobAssignmentId={this.getJobAssignmentId()}
          jobPositionPermissions={jobPositionPermissions}
          onSave={this.props.savePermissions}
        />
      )
    }
    return null
  }
  render () {
    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl={`/organizational-units/${this.props.match.params.id}`}>
            <Resx name='JobPosition.Permissions' />
          </MainTopTitle>
        </MainTop>
        <MainBody>
          <ErrorBoundary>
            {this.renderContent()}
          </ErrorBoundary>
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    jobPositionPermissions: state.jobPositionPermissions,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getPermissions: actionCreators.getPermissions,
  savePermissions: actionCreators.savePermissions
}

export default connect(mapStateToProps, mapDispatchToProps)(JobPositionPermissionDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/jobPositionPermissions/detail.js